/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Users_Skill_NameInputs */

const en_tables_users_skill_name = /** @type {(inputs: Tables_Users_Skill_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skill Name`)
};

const de_tables_users_skill_name = /** @type {(inputs: Tables_Users_Skill_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skill Name`)
};

/**
* | output |
* | --- |
* | "Skill Name" |
*
* @param {Tables_Users_Skill_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_users_skill_name = /** @type {((inputs?: Tables_Users_Skill_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Users_Skill_NameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_users_skill_name(inputs)
	return de_tables_users_skill_name(inputs)
});